module.exports = __webpack_public_path__ + "img/error.8d3acf62.png";